import React from "react";


const EditNotice = ({ form, setForm, setData }) => {
    const maxCharacters = 300;

    const updateNotice = (text) => {
        const trimmed = text.length > maxCharacters ? text.substring(0, maxCharacters) : text;
        setForm((data) => ({ ...data, "branch_notice": trimmed }));
        setData((i) => ({ ...i, "branch_notice": trimmed }));
    };

    const handleTextChange = (event) => {
        updateNotice(event.target.value);
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const paste = (e.clipboardData || window.clipboardData).getData('text');
        const textarea = e.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const currentText = form.branch_notice || '';
        const newText = currentText.substring(0, start) + paste + currentText.substring(end);
        updateNotice(newText);
        setTimeout(() => {
            const pos = Math.min(start + paste.length, Math.min(newText.length, maxCharacters));
            textarea.setSelectionRange(pos, pos);
        }, 0);
    };

    return (
        <div className="edit-warp-content-notice">
            <div>
                <p>預約注意事項將會顯示於預約畫面，用於提醒客戶。您可以選擇現在或之後再填寫。</p>

                <div>
                    <label>
                        <p>內容</p>
                        <p>
                            <span style={{ color: form.branch_notice && form.branch_notice.length >= maxCharacters ? '#e75264' : 'inherit' }}>
                                {form.branch_notice ? form.branch_notice.length : 0}
                            </span>
                            {' / '}{maxCharacters}
                        </p>
                    </label>

                    <textarea value={form.branch_notice} onChange={handleTextChange} onPaste={handlePaste}></textarea>
                </div>

                {/* <button>預覽</button> */}
            </div>
        </div>
    )
};


export default EditNotice;